










import gql from '../gqlService.coffee'

export default {
  "name": 'profile',
  "props":
    "text": false
    "icon": false
}
